<RbAuthHeader>
  <div slot="additionalControls">
    <TravelDestinationPicker  {destination} {rfpId} />
  </div>

  <div slot="mainControls">
    <div class="Inline">
      <a href="/" on:click|preventDefault|stopPropagation="{globalSearch}"
         class="aBtn asLarge CustomButton" data-icon="travel_explore">Global Search</a>
      <div class="rbTooltip">If you cannot find your hotel using our proximity search for this area, try searching our entire database</div>
    </div>

    <a href="/" on:click|preventDefault|stopPropagation="{() => toggleTable(true)}"
       class="aBtn asLarge CustomButton {tableShowing ? 'Active': ''}" data-icon="list">Properties List</a>

    <a href="/" on:click|preventDefault|stopPropagation="{() => toggleTable(false)}"
       class="aBtn asLarge CustomButton {!tableShowing ? 'Active': ''}" data-icon="map">Properties Map</a>
  </div>
</RbAuthHeader>


<script>
  import {createEventDispatcher} from 'svelte';
  import {SvelteDialog} from 'root/v-app/rbServices';

  import TravelDestinationPicker from './TravelDestinationPicker.svelte';
  import RbAuthHeader from './RbAuthHeader.svelte';
  import GlobalSearchDialog from './RbTravelDestinationGlobalSearchDialog.svelte';

  const dispatch = createEventDispatcher();

  export let tableShowing = false;
  export let destination;
  export let rfpId;

  function toggleTable(state) {
    dispatch('toggle', state);
  }

  function globalSearch(){
    SvelteDialog.show(GlobalSearchDialog, {rfpId, destination})
  }
</script>


<style lang="stylus">
  @import '../header.blocks.styl';

  .Inline {
    display: inline-block;
  }

  .aBtn.asLarge.CustomButton {
    {CustomButton}

    &.Active {
      {CustomButtonActive}
    }
  }
</style>